import red from '@material-ui/core/colors/red';
import blue from '@material-ui/core/colors/blue';
import green from '@material-ui/core/colors/green';
import yellow from '@material-ui/core/colors/yellow';


const rowStyleLivraison = (record, index, defaultStyle = {}) => {
    if (record && record.status==='ASK')
    return {
        ...defaultStyle,
        borderLeftColor: yellow[500],
        borderLeftWidth: 4,
        borderLeftStyle: 'solid',
    };
    
    if (record && record.livre_user_id === 0 )
        return {
            ...defaultStyle,
            borderLeftColor: blue[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };
  

        if (record && record.livre_user_id !== 0 && record.reste_a_payer===0)
        return {
            ...defaultStyle,
            borderLeftColor: green[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

        if (record && record.livre_user_id !== 0 && record.reste_a_payer!==0)
        return {
            ...defaultStyle,
            borderLeftColor: red[500],
            borderLeftWidth: 4,
            borderLeftStyle: 'solid',
        };

   



     
    return defaultStyle;

};

export default rowStyleLivraison;